module.exports = __webpack_public_path__ + "static/index/img/baikal-412.6a590880.jpg";